import { localizeItem } from '@/helpers/LocalizationHelper.js';

export default {
  getContent(state) {
    return state.content;
  },

  getJoboffers(state, _, rootState) {
    if (!state.filters) {
      return state.joboffers;
    }

    let jobs = state.joboffers;
    for (const [field, keyFilter] of Object.entries(state.filters)) {
      if (keyFilter.length > 0) {
        if (field === 'keyword') {
          const keyword = keyFilter[0].value;
          jobs = jobs.filter((x) =>
            x.name.some(
              (n) =>
                n.translation.toLowerCase().indexOf(keyword.toLowerCase()) >= 0
            )
          );
        } else if (field === 'companyId') {
          jobs = jobs.filter((x) =>
            keyFilter.some((kf) => kf.value === x.companyId)
          );
        } else if (field.endsWith('Id')) {
          const fieldName = field.replace('Id', '');
          jobs = jobs.filter((x) =>
            keyFilter.some(
              (kf) =>
                localizeItem(x[fieldName], rootState.currentLanguage) ===
                localizeItem(kf.name, rootState.currentLanguage)
            )
          );
        } else {
          jobs = jobs.filter((x) =>
            keyFilter.some(
              (kf) =>
                localizeItem(kf.name, rootState.currentLanguage) ===
                localizeItem(x[field], rootState.currentLanguage)
            )
          );
        }
      }
    }

    return jobs;
  },

  getCareerLevels(state, _, rootState) {
    const levels = [];
    const jobs = state.joboffers.filter(
      (x) =>
        rootState.companyModule.showBlacklistedJoboffers || !x.isBlacklisted
    );

    for (const job of jobs) {
      const matchingLevel = levels.find(
        (x) =>
          localizeItem(x.name, rootState.currentLanguage) ===
          localizeItem(job.careerLevel, rootState.currentLanguage)
      );
      if (matchingLevel) {
        matchingLevel.numJobs++;
      } else {
        levels.push({
          field: 'careerLevelId',
          id: job.careerLevelId,
          name: job.careerLevel,
          numJobs: 1
        });
      }
    }

    return levels;
  },

  getCategories(state, _, rootState) {
    const categories = [];
    const jobs = state.joboffers.filter(
      (x) =>
        rootState.companyModule.showBlacklistedJoboffers || !x.isBlacklisted
    );
    for (const job of jobs) {
      const matchingCategory = categories.find(
        (x) =>
          localizeItem(x.name, rootState.currentLanguage) ===
          localizeItem(job.category, rootState.currentLanguage)
      );
      if (matchingCategory) {
        matchingCategory.numJobs++;
      } else {
        categories.push({
          field: 'categoryId',
          id: job.categoryId,
          name: job.category,
          numJobs: 1
        });
      }
    }

    return categories;
  },

  getContractTypes(state, _, rootState) {
    const contractTypes = [];
    const jobs = state.joboffers.filter(
      (x) =>
        rootState.companyModule.showBlacklistedJoboffers || !x.isBlacklisted
    );
    for (const job of jobs) {
      const matchingContractType = contractTypes.find(
        (x) =>
          localizeItem(x.name, rootState.currentLanguage) ===
          localizeItem(job.contractType, rootState.currentLanguage)
      );
      if (matchingContractType) {
        matchingContractType.numJobs++;
      } else {
        contractTypes.push({
          field: 'contractTypeId',
          id: job.contractTypeId,
          name: job.contractType,
          numJobs: 1
        });
      }
    }

    return contractTypes;
  },

  getLocations(state, _, rootState) {
    const locations = [];
    const jobs = state.joboffers.filter(
      (x) =>
        rootState.companyModule.showBlacklistedJoboffers || !x.isBlacklisted
    );
    for (const job of jobs) {
      const matchingLocation = locations.find(
        (x) =>
          localizeItem(x.name, rootState.currentLanguage) ===
          localizeItem(job.location, rootState.currentLanguage)
      );
      if (matchingLocation) {
        matchingLocation.numJobs++;
      } else {
        locations.push({
          field: 'locationId',
          id: job.locationId,
          name: job.location,
          numJobs: 1
        });
      }
    }

    return locations;
  },

  getDepartments(state, _, rootState) {
    const departments = [];
    const jobs = state.joboffers.filter(
      (x) =>
        rootState.companyModule.showBlacklistedJoboffers || !x.isBlacklisted
    );

    console.log(rootState);
    for (const job of jobs) {
      if (job.departmentId <= 0) {
        continue;
      }

      const matchingDepartment = departments.find(
        (x) =>
          localizeItem(x.name, rootState.currentLanguage) ===
          localizeItem(job.department, rootState.currentLanguage)
      );

      if (matchingDepartment) {
        matchingDepartment.numJobs++;
      } else {
        departments.push({
          field: 'departmentId',
          id: job.departmentId,
          name: job.department,
          numJobs: 1
        });
      }
    }

    return departments;
  },

  getWorkingTimes(state, _, rootState) {
    const workingTimes = [];
    const jobs = state.joboffers.filter(
      (x) =>
        rootState.companyModule.showBlacklistedJoboffers || !x.isBlacklisted
    );
    for (const job of jobs) {
      if (job.workingTimeId < 0) {
        continue;
      }

      const matchingWorkingTime = workingTimes.find(
        (x) =>
          localizeItem(x.name, rootState.currentLanguage) ===
          localizeItem(job.workingTime, rootState.currentLanguage)
      );

      if (matchingWorkingTime) {
        matchingWorkingTime.numJobs++;
      } else {
        workingTimes.push({
          field: 'workingTimeId',
          id: job.workingTimeId,
          name: job.workingTime,
          numJobs: 1
        });
      }
    }

    return workingTimes;
  },

  getCostCenters(state, _, rootState) {
    const costCenters = [];
    const jobs = state.joboffers.filter(
      (x) =>
        rootState.companyModule.showBlacklistedJoboffers || !x.isBlacklisted
    );
    for (const job of jobs) {
      if (job.costCenterId < 0) {
        continue;
      }

      const matchingCostCenter = costCenters.find(
        (x) =>
          localizeItem(x.name, rootState.currentLanguage) ===
          localizeItem(job.costCenter, rootState.currentLanguage)
      );

      if (matchingCostCenter) {
        matchingCostCenter.numJobs++;
      } else {
        costCenters.push({
          field: 'costCenterId',
          id: job.costCenterId,
          name: job.costCenter,
          numJobs: 1
        });
      }
    }

    return costCenters;
  },

  getTempJobs(state, _, rootState) {
    const tempJobs = [];
    const jobs = state.joboffers.filter(
      (x) =>
        rootState.companyModule.showBlacklistedJoboffers || !x.isBlacklisted
    );
    for (const job of jobs) {
      if (job.tempJobId < 0) {
        continue;
      }

      const matchingTempJob = tempJobs.find(
        (x) =>
          localizeItem(x.name, rootState.currentLanguage) ===
          localizeItem(job.tempJob, rootState.currentLanguage)
      );

      if (matchingTempJob) {
        matchingTempJob.numJobs++;
      } else {
        tempJobs.push({
          field: 'tempJobId',
          id: job.tempJobId,
          name: job.tempJob,
          numJobs: 1
        });
      }
    }

    return tempJobs;
  },

  getCompanies(state, _, rootState) {
    const companies = [];
    const jobs = state.joboffers.filter(
      (x) =>
        rootState.companyModule.showBlacklistedJoboffers || !x.isBlacklisted
    );
    for (const job of jobs) {
      if (job.companyId <= 0) {
        continue;
      }

      const matchingCompany = companies.find(
        (x) =>
          localizeItem(x.name, rootState.currentLanguage) ===
          localizeItem(job.companyName, rootState.currentLanguage)
      );

      if (matchingCompany) {
        matchingCompany.numJobs++;
      } else {
        companies.push({
          field: 'companyId',
          id: job.companyId,
          name: job.companyName,
          numJobs: 1
        });
      }
    }

    return companies;
  }
};
